import ButtonUnderText from 'components/atoms/Button/Button.underText';
import { autoCompleteState } from 'modules/actions/autoComplete';
import { changeFontSize } from 'modules/actions/fontSize';
import useRequestDM from 'modules/hooks/useRequestDM';
import { disableAllMenu } from 'modules/actions/statusMenu';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { chatList } from 'modules/actions/chat';
/**
 * 하단의 메뉴 컴포넌트
 * @returns {object} ChatMenu
 */
const domainUrlParam = process.env.REACT_APP_DOMAIN_URL;

const ChatMenu = ({ styleDef, viewStatus }) => {
  const currentFontSize = useSelector(state => state.fontSize.size);
  const dispatch = useDispatch();

  const execOnSendMsg = text => {
    const paramSet = {
      inType: 'query',
      inStr: text,
      inLabel: text,
      parameters: sessionStorage.getItem('address')
        ? {
            latitude_y: sessionStorage.getItem('latitude_y'),
            longitude_x: sessionStorage.getItem('longitude_x'),
            address: sessionStorage.getItem('address'),
            position_status: 'Y',
          }
        : { latitude_y: '', longitude_x: '', position_status: 'N' },
    };
    dispatch(chatList(paramSet));
    dispatch(disableAllMenu());
  };

  return (
    <div className="_quick_div" style={styleDef}>
      <div className="_quick_menu">
        <ButtonUnderText
          label="분야별 안내"
          value="분야별 안내"
          image={`/${domainUrlParam}/ibricks/images/intro_icon1.png`}
          viewStatus={{ viewStatus }}
          styleDef={{}}
          onClickEvt={() => execOnSendMsg('분야별 안내')}
          error={null}
        />
        <ButtonUnderText
          label="담당 안내"
          value="담당 안내"
          image={`/${domainUrlParam}/ibricks/images/intro_icon2.png`}
          viewStatus={{ viewStatus }}
          styleDef={{}}
          onClickEvt={() => execOnSendMsg('담당 안내')}
          error={null}
        />
        <ButtonUnderText
          label="행정기관 위치"
          value="행정기관 위치"
          image={`/${domainUrlParam}/ibricks/images/intro_icon3.png`}
          viewStatus={{ viewStatus }}
          styleDef={{}}
          onClickEvt={() => execOnSendMsg('행정기관 위치')}
          error={null}
        />
        <ButtonUnderText
          label="처음으로"
          value="처음으로"
          image={`/${domainUrlParam}/ibricks/images/처음으로.png`}
          viewStatus={{ viewStatus }}
          styleDef={{}}
          onClickEvt={() => window.location.reload()}
          error={null}
        />
        <ButtonUnderText
          label="손바닥소식"
          value="손바닥소식"
          image={`/${domainUrlParam}/ibricks/images/intro_icon4.png`}
          viewStatus={{ viewStatus }}
          styleDef={{}}
          onClickEvt={() => execOnSendMsg('손바닥소식')}
          error={null}
        />
        <ButtonUnderText
          label="생활불편신고"
          value="생활불편신고"
          image={`/${domainUrlParam}/ibricks/images/intro_icon5.png`}
          viewStatus={{ viewStatus }}
          styleDef={{}}
          onClickEvt={() => execOnSendMsg('생활불편신고')}
          error={null}
        />
        <ButtonUnderText
          label="자주 하는 질문"
          value="자주 하는 질문"
          image={`/${domainUrlParam}/ibricks/images/intro_icon6.png`}
          viewStatus={{ viewStatus }}
          styleDef={{}}
          onClickEvt={() => execOnSendMsg('자주 하는 질문')}
          error={null}
        />
        <ButtonUnderText
          label="도움말"
          value="도움말"
          image={`/${domainUrlParam}/ibricks/images/도움말.png`}
          viewStatus={{ viewStatus }}
          styleDef={{}}
          onClickEvt={() => execOnSendMsg('도움말')}
          error={null}
        />
      </div>
    </div>
  );
};

ChatMenu.propTypes = {
  styleDef: PropTypes.object,
  viewStatus: PropTypes.bool,
};

ChatMenu.defaultProps = {
  styleDef: {},
  viewStatus: '',
};

export default ChatMenu;
